import { useMemo } from 'react';
import { StripeElementStyle } from '@stripe/stripe-js';

interface IStripeOptionFont {
  family: string;
  src: string;
  fontWeight: number;
}

interface IStripeOptionElement {
  fonts: IStripeOptionFont[];
}

export interface IStripeOption {
  style: StripeElementStyle;
  elements: IStripeOptionElement;
}

const useStripeOptions = () => {
  const options = useMemo<IStripeOption>(
    () => ({
      style: {
        base: {
          fontSize: '16px',
          color: '#1c1e1c',
          '::placeholder': {
            color: '#9a9897',
          },
          fontFamily:
            'lf-aktiv-grotesk, Arial, Avenir, Lucida Grande, Tahoma, Sans-Serif',
        },
        invalid: {
          color: '#e74524',
          iconColor: '#e74524',
        },
      },
      elements: {
        fonts: [
          {
            family: 'lf-aktiv-grotesk',
            src: "url('https://use.typekit.net/af/ab3e12/000000000000000077359d4f/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3') format('woff2')",
            fontWeight: 400,
          },
        ],
      },
    }),
    [],
  );

  return options;
};

export default useStripeOptions;
